var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 46,
    viewBox: "0 0 55 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3346 1.51433C51.6577 -0.213869 48.9588 -0.429427 47.0288 1.01069L17.7792 22.8361C16.3136 23.9297 16.159 26.0688 17.452 27.3619L23.9741 33.884C26.4907 36.4006 30.6321 36.186 32.8751 33.4229L53.6161 7.87255C55.1461 5.98773 55.0252 3.25658 53.3346 1.51433ZM0.704651 43.7045C27.5325 49.049 23.9206 37.9206 18.6354 32.6354C11.1151 25.1151 9.27876 29.4177 6.95502 34.8621C5.52967 38.2016 3.92095 41.9707 0.704651 43.7045Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryDesign);
export default __webpack_public_path__ + "react/media/category-design.e5729d045dba34a41679b23dba842e2d.svg";
export { ForwardRef as ReactComponent };